import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) { return twMerge(clsx(inputs)); }

export const formatSAR = (n) => {
  const v = Number(n || 0);
  return `SAR ${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatIDR = (n) => `Rp ${Math.round(Number(n || 0)).toLocaleString("id-ID")}`;

export const waLink = (phone, text) => `https://wa.me/${String(phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const buildWaMessage = (b, kind = "created") => {
  const inv = `${window.location.origin}/invoice/${b.code}`;
  const pdf = `${process.env.REACT_APP_BACKEND_URL}/api/public/invoice/${b.code}/pdf`;
  const reviewUrl = `${window.location.origin}/ulasan/${b.review_token}`;
  const trips = (b.trips || []).map((tr, i) => `${i + 1}. ${tr.route} — ${tr.vehicle_type}, ${tr.passengers} pax, ${String(tr.pickup_date).replace("T", " ")}`).join("\n");
  const head = `Assalamu'alaikum ${b.customer_name},\n`;
  if (kind === "review") return `${head}Alhamdulillah perjalanan Anda bersama Abdan Pro (${b.code}) telah selesai. Semoga ibadah Anda mabrur.\n\nKami sangat menghargai jika Anda berkenan memberi ulasan singkat (1 menit):\n${reviewUrl}\n\nJazakumullah khairan - Abdan Pro`;
  if (kind === "dp_paid") return `${head}Alhamdulillah, DP untuk booking *${b.code}* (${b.invoice_no}) telah kami terima. Pemesanan Anda TERKONFIRMASI.\n\n${trips}\n\nSisa pelunasan ${formatSAR(b.price - b.dp_amount)} dibayar di hari perjalanan.\nInvoice: ${inv}\n\nTerima kasih - Abdan Pro`;
  if (kind === "reminder") return `${head}Mengingatkan DP ${b.dp_percent}% untuk booking *${b.code}* sebesar ${formatIDR(b.dp_amount_idr)} (${formatSAR(b.dp_amount)}) belum kami terima. Detail rekening ada di invoice: ${inv}\n\nTerima kasih - Abdan Pro`;
  return `${head}Terima kasih telah memesan di Abdan Pro.\nKode booking: *${b.code}*\nInvoice: ${b.invoice_no}\n\n${trips}\n\nTotal: ${formatSAR(b.price)}\nDP ${b.dp_percent}%: ${formatIDR(b.dp_amount_idr)} (${formatSAR(b.dp_amount)})\nPelunasan di hari perjalanan.\n\nInvoice & rekening transfer: ${inv}\nInvoice PDF: ${pdf}\nSetelah transfer, unggah bukti di halaman invoice.\n\n- Abdan Pro`;
};

export const formatDate = (iso, locale = "en-US") => {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString(locale, { dateStyle: "medium", timeStyle: "short" }); }
  catch { return iso; }
};

export const statusColor = (s) => ({
  pending: "bg-amber-100 text-amber-800 border-amber-300",
  confirmed: "bg-sky-100 text-sky-800 border-sky-300",
  dispatched: "bg-indigo-100 text-indigo-800 border-indigo-300",
  "in-progress": "bg-emerald-100 text-emerald-800 border-emerald-300",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  cancelled: "bg-rose-100 text-rose-800 border-rose-300",
  available: "bg-emerald-100 text-emerald-800 border-emerald-300",
  "in-service": "bg-sky-100 text-sky-800 border-sky-300",
  maintenance: "bg-amber-100 text-amber-800 border-amber-300",
  active: "bg-emerald-100 text-emerald-800 border-emerald-300",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-300",
  unpaid: "bg-rose-100 text-rose-800 border-rose-300",
  dp_paid: "bg-amber-100 text-amber-800 border-amber-300",
}[s] || "bg-slate-100 text-slate-700 border-slate-300");
